// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-value-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.cell-value-modal {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    width: 90%;
    max-width: 800px;
    max-height: calc(80vh / var(--app-zoom, 1));
    display: flex;
    flex-direction: column;
}

.cell-value-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e0e0e0;
}

.cell-value-modal-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.cell-value-modal-actions {
    display: flex;
    gap: 8px;
}

.copy-button {
    padding: 6px 12px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    transition: background-color 0.2s;
}

.copy-button:hover {
    background-color: #0056b3;
}

.close-button {
    background: transparent;
    border: none;
    color: #666;
    font-size: 24px;
    cursor: pointer;
    padding: 0 8px;
    line-height: 1;
    transition: color 0.2s;
}

.close-button:hover {
    color: #d32f2f;
}

.cell-value-modal-content {
    flex: 1 1;
    overflow: auto;
    padding: 16px 20px;
    background-color: #f8f9fa;
}

.cell-value-modal-content pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.5;
    color: #333;
}

.cell-value-modal-footer {
    padding: 12px 20px;
    border-top: 1px solid #e0e0e0;
    background-color: #fafafa;
}

.value-info {
    font-size: 12px;
    color: #666;
}

/* 다크 모드 — 그리드 셀 값 popup */
[data-theme="dark"] .cell-value-modal-backdrop {
    background-color: rgba(0, 0, 0, 0.65);
}
[data-theme="dark"] .cell-value-modal {
    background: var(--color-bg);
    color: var(--color-text);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.55);
    border: 1px solid var(--color-border);
}
[data-theme="dark"] .cell-value-modal-header {
    border-bottom-color: var(--color-border);
}
[data-theme="dark"] .cell-value-modal-header h3 {
    color: var(--color-text);
}
[data-theme="dark"] .copy-button {
    background-color: #2563eb;
    color: #fff;
}
[data-theme="dark"] .copy-button:hover {
    background-color: #1d4ed8;
}
[data-theme="dark"] .close-button {
    color: var(--color-text-muted);
}
[data-theme="dark"] .close-button:hover {
    color: #ff6b6b;
}
[data-theme="dark"] .cell-value-modal-content {
    background-color: var(--color-bg-secondary);
}
[data-theme="dark"] .cell-value-modal-content pre {
    color: var(--color-text);
}
[data-theme="dark"] .cell-value-modal-footer {
    background-color: var(--color-bg-secondary);
    border-top-color: var(--color-border);
}
[data-theme="dark"] .value-info {
    color: var(--color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/CellValueModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,gBAAgB;IAChB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,qBAAqB;IACrB,2DAA2D;IAC3D,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,0BAA0B;AAC1B;IACI,qCAAqC;AACzC;AACA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,0CAA0C;IAC1C,qCAAqC;AACzC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,2CAA2C;IAC3C,qCAAqC;AACzC;AACA;IACI,8BAA8B;AAClC","sourcesContent":[".cell-value-modal-backdrop {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 10000;\r\n}\r\n\r\n.cell-value-modal {\r\n    background: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\r\n    width: 90%;\r\n    max-width: 800px;\r\n    max-height: calc(80vh / var(--app-zoom, 1));\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.cell-value-modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 16px 20px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.cell-value-modal-header h3 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.cell-value-modal-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.copy-button {\r\n    padding: 6px 12px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.copy-button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.close-button {\r\n    background: transparent;\r\n    border: none;\r\n    color: #666;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    padding: 0 8px;\r\n    line-height: 1;\r\n    transition: color 0.2s;\r\n}\r\n\r\n.close-button:hover {\r\n    color: #d32f2f;\r\n}\r\n\r\n.cell-value-modal-content {\r\n    flex: 1;\r\n    overflow: auto;\r\n    padding: 16px 20px;\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.cell-value-modal-content pre {\r\n    margin: 0;\r\n    white-space: pre-wrap;\r\n    word-wrap: break-word;\r\n    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\r\n    font-size: 13px;\r\n    line-height: 1.5;\r\n    color: #333;\r\n}\r\n\r\n.cell-value-modal-footer {\r\n    padding: 12px 20px;\r\n    border-top: 1px solid #e0e0e0;\r\n    background-color: #fafafa;\r\n}\r\n\r\n.value-info {\r\n    font-size: 12px;\r\n    color: #666;\r\n}\r\n\r\n/* 다크 모드 — 그리드 셀 값 popup */\r\n[data-theme=\"dark\"] .cell-value-modal-backdrop {\r\n    background-color: rgba(0, 0, 0, 0.65);\r\n}\r\n[data-theme=\"dark\"] .cell-value-modal {\r\n    background: var(--color-bg);\r\n    color: var(--color-text);\r\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.55);\r\n    border: 1px solid var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .cell-value-modal-header {\r\n    border-bottom-color: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .cell-value-modal-header h3 {\r\n    color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .copy-button {\r\n    background-color: #2563eb;\r\n    color: #fff;\r\n}\r\n[data-theme=\"dark\"] .copy-button:hover {\r\n    background-color: #1d4ed8;\r\n}\r\n[data-theme=\"dark\"] .close-button {\r\n    color: var(--color-text-muted);\r\n}\r\n[data-theme=\"dark\"] .close-button:hover {\r\n    color: #ff6b6b;\r\n}\r\n[data-theme=\"dark\"] .cell-value-modal-content {\r\n    background-color: var(--color-bg-secondary);\r\n}\r\n[data-theme=\"dark\"] .cell-value-modal-content pre {\r\n    color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .cell-value-modal-footer {\r\n    background-color: var(--color-bg-secondary);\r\n    border-top-color: var(--color-border);\r\n}\r\n[data-theme=\"dark\"] .value-info {\r\n    color: var(--color-text-muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
